/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StepStateType } from './StepStateType';
import {
    StepStateTypeFromJSON,
    StepStateTypeFromJSONTyped,
    StepStateTypeToJSON,
} from './StepStateType';

/**
 * 
 * @export
 * @interface Step3Scenarios
 */
export interface Step3Scenarios {
    /**
     * 
     * @type {number}
     * @memberof Step3Scenarios
     */
    scenarioId?: number;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step3Scenarios
     */
    scenarioState: StepStateType;
}

/**
 * Check if a given object implements the Step3Scenarios interface.
 */
export function instanceOfStep3Scenarios(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scenarioState" in value;

    return isInstance;
}

export function Step3ScenariosFromJSON(json: any): Step3Scenarios {
    return Step3ScenariosFromJSONTyped(json, false);
}

export function Step3ScenariosFromJSONTyped(json: any, ignoreDiscriminator: boolean): Step3Scenarios {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scenarioId': !exists(json, 'ScenarioId') ? undefined : json['ScenarioId'],
        'scenarioState': StepStateTypeFromJSON(json['ScenarioState']),
    };
}

export function Step3ScenariosToJSON(value?: Step3Scenarios | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ScenarioId': value.scenarioId,
        'ScenarioState': StepStateTypeToJSON(value.scenarioState),
    };
}

